import { memo, useCallback, useState } from 'react';
import ShareButtonSaveModal from './ShareButtonSaveModal';
import ShareButtonViewsModal from './ShareButtonViewsModal';

export interface ShareButtonModalsProps {
  onClose: () => void;
}
const ShareButtonModals = ({ onClose }: ShareButtonModalsProps) => {
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const [viewsModalOpen, setViewsModalOpen] = useState(true);

  const onViewsModalClosed = useCallback(() => {
    setViewsModalOpen(false);
    onClose();
  }, [onClose]);
  const onSaveModalClosed = useCallback(
    (cancelled: boolean) => {
      setSaveModalOpen(false);
      if (!cancelled) onClose();
    },
    [onClose]
  );

  const onSave = useCallback(() => {
    setSaveModalOpen(true);
  }, []);

  return (
    <>
      {saveModalOpen && <ShareButtonSaveModal onClose={onSaveModalClosed} />}
      {viewsModalOpen && <ShareButtonViewsModal onClose={onViewsModalClosed} onSave={onSave} />}
    </>
  );
};
export default memo(ShareButtonModals);
